export default __webpack_public_path__ + "static/media/MadelineRijo1.312dd152.png";